import { useForm } from 'react-hook-form'
import moment from 'moment'
import RadioGroup from './RadioGroup'
import useAddUserDetails from '../hooks/useAddUserDetails'
import { useEffect } from 'react'
import ArrowIcon from '../../../components/atoms/Arrow'
import Text from '../../../components/atoms/Text'
import Button from '../../../components/atoms/GoodFlipButton'
import InputField from '../../../components/atoms/InputField'
import DatePicker from '../../../components/atoms/DatePicker'

const AddUserDetails = ({ onProceed }) => {
  const {
    error,
    loading,
    onSubmit,
    formFields,
    success,
    detailsUpdated,
    defaultFormValues,
  } = useAddUserDetails()
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      ...defaultFormValues,
    },
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  })

  useEffect(() => {
    if (!loading && !error && detailsUpdated) {
      onProceed()
    }
  }, [loading, success, error, detailsUpdated])

  return (
    <div className="px-4 pb-20 pt-4 space-y-5">
      <Text
        tag="p"
        variant="display"
        size="small"
        className={'text-text-primary'}
      >
        Add Details
      </Text>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
        {formFields.map((field) => {
          switch (field.inputType) {
            case 'radio':
              return (
                <RadioGroup
                  key={field.name}
                  field={field}
                  register={register}
                  watch={watch}
                />
              )

            case 'date':
              return (
                <div key={field.name}>
                  <DatePicker
                    placeholder="Select a date"
                    label="Date of Birth"
                    value={getValues('dob').toString()}
                    onChange={(e) => {
                      if (e) {
                        setValue('dob', moment(e).toDate().toString(), {
                          shouldValidate: true,
                        })
                      }
                    }}
                  />
                </div>
              )

            default:
              return (
                <div key={field.name}>
                  <InputField
                    label={field.label}
                    placeholder={field.placeholder}
                    autoFocus={field.autoFocus}
                    type={field.type}
                    minLength={field.minLength}
                    maxLength={field.maxLength}
                    error={Boolean(errors[field.name]?.message)}
                    errorMessage={errors[field.name]?.message}
                    {...register(field.name, field.validation)}
                  />
                </div>
              )
          }
        })}

        <div className="fixed max-w-lg lg:max-w-5xl xl:max-w-6xl mx-auto bottom-0 left-0 right-0 bg-WHITE py-4 shadow-lg">
          <Button
            isSubmitButton
            title="Proceed"
            disabled={!isValid || loading}
            loading={loading}
            type="goodflip_primary"
            leftIcon={null}
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
          />
        </div>
      </form>
    </div>
  )
}

export default AddUserDetails
